import ReactGA from 'react-ga'

function createNewApp() {
  ReactGA.event({
    category: 'Button',
    action: 'Click',
    label: 'Create New App',
  })
}

function createAccountNav() {
  ReactGA.event({
    category: 'Button',
    action: 'Click',
    label: 'Create Account Nav',
  })
}

function createAccountBody() {
  ReactGA.event({
    category: 'Button',
    action: 'Click',
    label: 'Create Account Body',
  })
}

function readDocsNav() {
  ReactGA.event({
    category: 'Button',
    action: 'Click',
    label: 'Read the Docs Nav',
  })
}

function readDocsBody() {
  ReactGA.event({
    category: 'Button',
    action: 'Click',
    label: 'Read the Docs Body',
  })
}

export const gaEvents = {
  createNewApp,
  createAccountNav,
  createAccountBody,
  readDocsNav,
  readDocsBody,
}
